// Coach Configuration
export const COACH_CONFIG = {
  coachUserId: '0XsVJ0zyZ0TgpKkeLIWzJ2FBuq93',
  coachName: 'KinOS',
  gymName: 'KinOS',
  apiBaseUrl: 'https://kinos-api.onrender.com/api'
};

// You can add more coach-specific configuration here
export const COACH_DETAILS = {
  name: 'Heather (HT)',
  email: 'davies@usekinos.com',
  location: 'San Francisco, CA',
  specialties: ['Sales', 'Marketing', 'Coaching', 'Freelancing', 'Consulting'],
  experience: '8+ years',
  clientsTrained: '500+',
  successRate: '95%'
}; 